import React, { useState, useEffect } from "react";
import { Table, DatePicker, Select, Button, message } from "antd";
import { useNavigate } from "react-router-dom";

const { Option } = Select;

function Reports() {

    const navigate = useNavigate();

    // Filters state
    const [region, setRegion] = useState("");
    const [warehouse, setWarehouse] = useState("");
    const [date, setDate] = useState(null);
    const [availablePercent, setAvailablePercent] = useState("");

    // Table data
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Example options for filters (replace with API if needed)
    const regionOptions = ["North", "South", "East", "West"];
    const warehouseOptions = ["Warehouse A", "Warehouse B", "Warehouse C"];
    const availableOptions = [10, 20, 50, 70, 90, 100];

    // Table columns
    const columns = [
        {
            title: "Region",
            dataIndex: "region",
            key: "region",
            align: "center",
        },
        {
            title: "Warehouse",
            dataIndex: "warehouse",
            key: "warehouse",
            align: "center",
        },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            align: "center",
        },
        {
            title: "Total Capacity",
            dataIndex: "totalCapacity",
            key: "totalCapacity",
            align: "center",
        },
        {
            title: "Occupied",
            dataIndex: "occupied",
            key: "occupied",
            align: "center",
        },
        {
            title: "Available (%)",
            dataIndex: "availablePercent",
            key: "availablePercent",
            align: "center",
        },
    ];

    // Mock API call
    const fetchTableData = async (filters) => {
        try {
            setLoading(true);

            // Example: Replace with real API call
            // const res = await axios.get("/api/warehouse", { params: filters });

            // Mock data
            const res = [
                {
                    key: 1,
                    region: "North",
                    warehouse: "Warehouse A",
                    date: "2026-03-05",
                    totalCapacity: 1000,
                    occupied: 800,
                    availablePercent: 20,
                },
                {
                    key: 2,
                    region: "South",
                    warehouse: "Warehouse B",
                    date: "2026-03-05",
                    totalCapacity: 1200,
                    occupied: 1000,
                    availablePercent: 16.7,
                },
            ];

            // Filter data according to filters
            const filtered = res.filter((item) => {
                let match = true;
                if (filters.region) match = match && item.region === filters.region;
                if (filters.warehouse) match = match && item.warehouse === filters.warehouse;
                if (filters.date) match = match && item.date === filters.date.format("YYYY-MM-DD");
                if (filters.availablePercent)
                    match = match && item.availablePercent >= Number(filters.availablePercent);
                return match;
            });

            setTableData(filtered);
        } catch (err) {
            console.error(err);
            message.error("Failed to fetch data");
        } finally {
            setLoading(false);
        }
    };

    // Handle Submit
    const handleSubmit = () => {
        fetchTableData({ region, warehouse, date, availablePercent });
    };

    return (
        <div className="container mt-4">

            {/* Top bar */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3 className="text-primary">Warehouse Report</h3>
                <Button
                    type="default"
                    onClick={() => navigate(-1)} // go back
                >
                    <i className="bi bi-arrow-left"></i>
                    Back
                </Button>
            </div>

            {/* Filters */}
            <div className="row g-3 mb-4">
                <div className="col-md-2">
                    <label className="fw-semibold">Region</label>
                    <Select
                        placeholder="Select Region"
                        value={region || undefined}
                        onChange={setRegion}
                        className="w-100"
                    >
                        {regionOptions.map((r) => (
                            <Option key={r} value={r}>{r}</Option>
                        ))}
                    </Select>
                </div>

                <div className="col-md-2">
                    <label className="fw-semibold">Warehouse</label>
                    <Select
                        placeholder="Select Warehouse"
                        value={warehouse || undefined}
                        onChange={setWarehouse}
                        className="w-100"
                    >
                        {warehouseOptions.map((w) => (
                            <Option key={w} value={w}>{w}</Option>
                        ))}
                    </Select>
                </div>

                <div className="col-md-2">
                    <label className="fw-semibold">Date</label>
                    <DatePicker
                        value={date}
                        onChange={setDate}
                        className="w-100"
                    />
                </div>

                <div className="col-md-2">
                    <label className="fw-semibold">Available ≥ %</label>
                    <Select
                        placeholder="Select %"
                        value={availablePercent || undefined}
                        onChange={setAvailablePercent}
                        className="w-100"
                    >
                        <Option value="all">All</Option>
                        {availableOptions.map((p) => (
                            <Option key={p} value={p}>{`>${p}%`}</Option>
                        ))}
                    </Select>
                </div>
                <div className="col-md-2 d-flex align-items-end">
                    <Button type="primary" onClick={handleSubmit}>
                        Submit
                    </Button>
                </div>
            </div>

            {/* Table */}
            <div className="card shadow-sm border-0">
                <div className="card-body">
                    <Table
                        className="custom-ant-table"
                        columns={columns}
                        dataSource={tableData}
                        bordered
                        loading={loading}
                        scroll={{ x: "max-content" }} // horizontal scroll on mobile
                        pagination={{
                            showSizeChanger: true,
                            pageSizeOptions: ["10", "20", "50"],
                            position: ["bottomRight"]
                        }}
                    />
                </div>
            </div>

        </div>
    );
};

export default Reports;